module.exports = __webpack_public_path__ + "static/media/MENU_UNIDADES.c68ea6e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/MENU_UNIDADES.svg
// module id = 495
// module chunks = 0